import {Switch} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import {i18n2} from 'features/i18n/i18n';
import {Field} from 'formik';
import {TextField} from 'formik-material-ui';
import React from 'react';

const Dominio = ({formikProps}) => {
  return (
    <Grid container spacing={2}>
      <Grid item md={3} xs={12}>
        <Field
          component={Switch}
          name="validateDomain"
          label={i18n2._('Validar Dominio')}
          checked={formikProps.values['validateDomain']}
          onChange={(e) => {
            formikProps.setFieldValue('validateDomain', e.target.checked);
          }}
        />
        <p style={{display: 'inline'}}>{i18n2._('Validar dominio')}</p>
      </Grid>
      <Grid item md={6} xs={12}>
        <Field
          name="domain"
          component={TextField}
          label={i18n2._('Dominio')}
          fullWidth
          variant="outlined"
          disabled={!formikProps.values.validateDomain}
          size={'small'}
        />
      </Grid>
    </Grid>
  );
};

export default Dominio;
